import angular from 'angular';
import { MeurhCreditosdescontosService } from './creditosdescontos.service';

export const MeurhCreditosdescontosListRouting = ['$stateProvider', function ($stateProvider: angular.ui.IStateProvider) {
    const resolve = {
        'entity': [
            'MeurhCreditosdescontosService',
            '$rootScope',
            '$stateParams',
            '$state',
            '$q',
            function (
                entityService: MeurhCreditosdescontosService,
                $rootScope: angular.IRootScopeService & { session: any },
                $stateParams: angular.ui.IStateParamsService,
                $state: angular.ui.IStateService,
                $q: angular.IQService
            ) {
                if (!$stateParams['solicitacao']) {
                    return $q<void>(() => $state.go('creditosdescontos_index'));
                }

                return entityService.get($stateParams['solicitacao'])
                    .then((data) => {
                        const deveRedirecionar = data.estabelecimento !== $rootScope.session.entities.estabelecimento.estabelecimento;
                        if (deveRedirecionar) {
                            return $q(() => $state.go('creditosdescontos_index'));
                        }

                        return data;
                    })
                    .catch((error) => {
                        if (error.status === 404) {
                            return $q(() => $state.go('not_found', $stateParams));
                        }

                        return $q.reject(error);
                    });
            }
        ]
    };

    $stateProvider
        .state('creditosdescontos', {
            url: '/registrarcompleto/{passoumativo}/?trabalhador',
            template: require('html-loader!./wizard/creditosdescontos.wizard.html'),
            controller: 'Meurh\CreditosdescontosWizardController',
            controllerAs: 'mrh_crdtsdscnts_wizard_cntrllr',
            reloadOnSearch: false
        })
        .state('creditosdescontos_show', {
            url: '/registrarcompleto/show/?solicitacao?path',
            template: require('html-loader!./show/creditosdescontos.show.html'),
            resolve,
            controller: 'Meurh\CreditosdescontosShowController',
            controllerAs: 'mrh_crdtsdscnts_shw_cntrllr',
        })
        .state('creditosdescontos_edit', {
            url: '/registrarcompleto/edit/?solicitacao',
            template: require('html-loader!./edit/creditosdescontos.edit.html'),
            resolve,
            controller: 'Meurh\CreditosdescontosEditController',
            controllerAs: 'mrh_crdtsdscnts_edt_cntrllr',
        })
        .state('creditosdescontos_index', {
            url: '/registrarcompleto',
            template: require('html-loader!./index/creditosdescontos.index.html'),
            controller: 'Meurh\CreditosdescontosListController',
            controllerAs: 'mrh_crdtsdscts_lst_cntrllr',
            reloadOnSearch: false
        })
        .state('creditosdescontos_showbuiltin', {
            parent: 'creditosdescontos_index',
            url: '/showbuiltin/:solicitacao',
            template: require('html-loader!./showbuiltin/creditosdescontos.showbuiltin.html'),
            resolve,
            controller: 'Meurh\CreditosdescontosShowbuiltinController',
            controllerAs: 'mrh_crdtsdscnts_shwbltn_cntrllr',
        })
        .state('creditosdescontos_editbuiltin', {
            parent: 'creditosdescontos_index',
            url: '/editbuiltin/:solicitacao',
            template: require('html-loader!./editbuiltin/creditosdescontos.editbuiltin.html'),
            resolve,
            controller: 'Meurh\CreditosdescontosEditbuiltinController',
            controllerAs: 'mrh_crdtsdscnts_edtbltn_cntrllr',
        });

}];
